
// let parentElement = document.querySelector("#HeaderMenu-descarca-catalog-copfer > span");
// let mobileParentElement = document.querySelector("#HeaderDrawer-descarca-catalog-copfer");
// try {
// parentElement.insertAdjacentHTML('afterend', '<img src="https://cdn.shopify.com/s/files/1/0713/6657/4299/files/download_8.png?v=1722914718" class="img-fluid download__img" alt="Download">');
// mobileParentElement.insertAdjacentHTML('beforeend', '<img src="https://cdn.shopify.com/s/files/1/0713/6657/4299/files/download_8.png?v=1722914718" class="img-fluid download__img" alt="Download">');
// } catch (error) {
// }


document.addEventListener('DOMContentLoaded', function () {

  // Работает только на copfer.eu
  if (window.location.hostname !== 'copfer.eu') {
    return;
  }

  let parentElement = document.querySelector(
    "#HeaderMenu-descarca-catalog-copfer > span"
  );

  let mobileParentElement = document.querySelector(
    "#HeaderDrawer-descarca-catalog-copfer"
  );

  // Определяем язык страницы
  let lang = document.documentElement.lang || '';

  // EN catalog
  let catalogUrl = 'https://cdn.shopify.com/s/files/1/0713/6657/4299/files/Catalog_Copfer_A4_Final_2026_EN_-_compressed.pdf?v=1788242707';

  // DE catalog
  if (lang.toLowerCase().startsWith('de')) {
    catalogUrl = 'https://cdn.shopify.com/s/files/1/0713/6657/4299/files/Catalog_Copfer_A4_Final_2026_DE_-_compressed.pdf?v=1788242707';
  }

  try {

    // Desktop
    if (parentElement) {
      parentElement.insertAdjacentHTML(
        'afterend',
        '<img src="https://cdn.shopify.com/s/files/1/0713/6657/4299/files/download_8.png?v=1722914718" class="img-fluid download__img" alt="Download">'
      );

      let desktopLink = parentElement.closest('a');

      if (desktopLink) {
        desktopLink.href = catalogUrl;
        desktopLink.target = '_blank';
      }
    }

    // Mobile
    if (mobileParentElement) {
      mobileParentElement.insertAdjacentHTML(
        'beforeend',
        '<img src="https://cdn.shopify.com/s/files/1/0713/6657/4299/files/download_8.png?v=1722914718" class="img-fluid download__img" alt="Download">'
      );

      let mobileLink = mobileParentElement.closest('a');

      if (mobileLink) {
        mobileLink.href = catalogUrl;
        mobileLink.target = '_blank';
      }
    }

  } catch (error) {
    console.error('Copfer catalog menu error:', error);
  }

});


// document.addEventListener("DOMContentLoaded", function() {

//     document.addEventListener('click', function(event) {
//         console.log(event.target.classList);
//     });
// });

document.addEventListener("click", handleBannerClick);

function handleBannerClick(event) {

  try {
  event.target.classList.contains("banner__content") ? bannerClick() : false;
  event.target.classList.contains("slideshow__text") ? bannerClick() : false;
  event.target.classList.contains("brand-link") ? bannerClick() : false;
  event.target.classList.contains("multicolumn-card") ? bannerClick() : false;
  event.target.classList.contains("dope") ? bannerClick() : false;
  if (event.target.classList.contains("dope")) {
    event.target.click();
  }
  } catch (error) {
    
  }
  function bannerClick() {
    event.target.previousElementSibling.click();
  }
}


// Function to add click event listeners to all elements with class 'product__media-toggle'
function setupMediaToggleListeners() {
  // Select the media gallery element
  let mediaGallery = document.querySelector("#media-gallery");

  // Check if the mediaGallery element exists
  if (mediaGallery) {
    // Select all elements with the class 'product__media-toggle'
    let mediaToggles = document.querySelectorAll(".product__media-toggle") || document.querySelectorAll(".product__media")  ;

    // Add click event listeners to each media toggle
    mediaToggles.forEach(function(toggle) {
      toggle.addEventListener("click", function(event) {
        // Prevent the default action of the click (if needed)
        event.preventDefault();

        // Trigger a click event on the mediaGallery element
        mediaGallery.click();
      });
    });
  } else {
    console.error("Element #mediaGallery not found.");
  }
}

// Run the setup if the page URL includes '/product/'
document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname.includes('/products/')) {
        setupMediaToggleListeners();
    }
});


try {
    // Add target="_blank" to the first element
    var headerMenuLink = document.querySelector("#HeaderMenu-descarca-catalog-copfer");
    if (headerMenuLink) {
        headerMenuLink.setAttribute("target", "_blank");
    } else {
        
    }
} catch (error) {
    
}

try {
    // Add target="_blank" to the second element
    var headerDrawerLink = document.querySelector("#HeaderDrawer-descarca-catalog-copfer");
    if (headerDrawerLink) {
        headerDrawerLink.setAttribute("target", "_blank");
    } else {
       
    }
} catch (error) {
   
}


// document.addEventListener('DOMContentLoaded', () => {
//   try {
//     const host = window.location.hostname;

//     // .md
//     if (host.endsWith('.md')) {
//       const el = document.querySelector(
//         '#Slide-template--18224975872219__featured_collection_DHWAtY-2'
//       );

//       if (el) {
//         el.remove();
//       }
//     }

//     // .ro
//     else if (host.endsWith('.ro')) {
//       const el = document.querySelector(
//         '#Slide-template--18224975872219__featured_collection_DHWAtY-3'
//       );

//       if (el) {
//         el.remove();
//       }
//     }
//   } catch (e) {
//     console.error('Element remove error:', e);
//   }
// });


// document.addEventListener('DOMContentLoaded', () => {
//   try {
//     const url = window.location.href.toLowerCase();

//     // Check product URLs
//     if (
//       url.includes('oferta-12') ||
//       url.includes('oferta-10')
//     ) {
//       const style = document.createElement('style');

//       style.innerHTML = `
//         #shopify-section-template--18224976036059__related-products 
//         > div 
//         > product-recommendations 
//         > ul 
//         > li:nth-child(7) {
//           display: none !important;
//         }
//       `;

//       document.head.appendChild(style);
//     }
//   } catch (e) {
//     console.error('CSS inject error:', e);
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.hostname.endsWith('.ro')) {
    [
      "#link-despre-noi > div > ul > li:nth-child(2)",
      "#link-despre-noi > div > ul > li:nth-child(3)",
      "#MegaMenu-Content-2 > ul > li:nth-child(2)",
      "#MegaMenu-Content-2 > ul > li:nth-child(3)"
    ].forEach(selector => {
      document.querySelector(selector)?.classList.add('d-none');
    });
  }
});